export type PlatformErrorInfo = {
  code: number;
  status: number;
  request_id: string;
  message: string;
  response?: Record<string, any>;
};
export default class AppletError extends Error {
  code: string;

  platformInfo?: PlatformErrorInfo;

  constructor(
    code: string,
    message: string,
    platformInfo: PlatformErrorInfo | undefined = undefined,
  ) {
    super(message);
    this.code = code;
    this.platformInfo = platformInfo;
  }

  toJson(): Record<string, any> {
    return {
      isError: true,
      error: {
        code: this.code,
        message: this.message,
        platform: this.platformInfo,
      },
    };
  }

  public static createPlatformError(platform: PlatformErrorInfo): AppletError {
    return new AppletError('platform_error', 'Error originating from platform request', platform);
  }
}

const DefaultErrors = {
  INIT_ERROR: new AppletError(
    'init_error',
    'SDK needs to be initialized before this api can be accessed',
  ),
  INVALID_USER_SESSION: new AppletError('invalid_user_session', 'The refresh token is invalid'),
  UNABLE_TO_REFRESH_TOKEN: new AppletError(
    'unable_to_fresh_token',
    'Some reason other then an invalid refresh token is preventing the refreshing of the access token',
  ),
  DATABASE_ACCESS_DENIED: new AppletError(
    'db_access_denied',
    'Unable to access the db. Check user storage permission',
  ),
  AWS_WAF_CAPTCHA_REQUIRED: new AppletError('aws-waf_captcha_required', 'AWS Waf Captcha required'),
  AWS_WAF_REQUEST_BLOCKED: new AppletError(
    'aws-waf_request_blocked',
    `Request blocked. Can't connect to the server at this time. There might be too much traffic or a configuration error. Try again later.`,
  ),
};

export { DefaultErrors };
